/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormUpdateStatusDto } from '../../models/form-update-status-dto';
import { FormUpdateStatusResponseDto } from '../../models/form-update-status-response-dto';

export interface UpdateStatus$Params {
  formId: string;
  body: FormUpdateStatusDto;
}

export function updateStatus(
  http: HttpClient,
  rootUrl: string,
  params: UpdateStatus$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormUpdateStatusResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updateStatus.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormUpdateStatusResponseDto>;
    })
  );
}

updateStatus.PATH = '/forms/{formId}/status';
